const WarningIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8333 23.75C16.2819 23.75 16.658 23.5983 16.9615 23.2948C17.2649 22.9913 17.4167 22.6153 17.4167 22.1667C17.4167 21.7181 17.2649 21.342 16.9615 21.0385C16.658 20.7351 16.2819 20.5833 15.8333 20.5833C15.3847 20.5833 15.0087 20.7351 14.7052 21.0385C14.4017 21.342 14.25 21.7181 14.25 22.1667C14.25 22.6153 14.4017 22.9913 14.7052 23.2948C15.0087 23.5983 15.3847 23.75 15.8333 23.75ZM14.25 17.4167H17.4167V7.91667H14.25V17.4167ZM15.8333 31.6667C13.6431 31.6667 11.5847 31.251 9.65833 30.4198C7.73194 29.5885 6.05625 28.4604 4.63125 27.0354C3.20625 25.6104 2.07812 23.9347 1.24687 22.0083C0.415625 20.0819 0 18.0236 0 15.8333C0 13.6431 0.415625 11.5847 1.24687 9.65833C2.07812 7.73194 3.20625 6.05625 4.63125 4.63125C6.05625 3.20625 7.73194 2.07812 9.65833 1.24687C11.5847 0.415625 13.6431 0 15.8333 0C18.0236 0 20.0819 0.415625 22.0083 1.24687C23.9347 2.07812 25.6104 3.20625 27.0354 4.63125C28.4604 6.05625 29.5885 7.73194 30.4198 9.65833C31.251 11.5847 31.6667 13.6431 31.6667 15.8333C31.6667 18.0236 31.251 20.0819 30.4198 22.0083C29.5885 23.9347 28.4604 25.6104 27.0354 27.0354C25.6104 28.4604 23.9347 29.5885 22.0083 30.4198C20.0819 31.251 18.0236 31.6667 15.8333 31.6667Z"
      fill="#F05924"
    />
  </svg>
);

export default WarningIcon;
